export const domain = "trellistudios.us.auth0.com";
export const clientId = "SVBj7gCtQ63dtJhIngoqPIEkoMQYe4uR";
export const audience = 'https://www.weavr.cc/';
//export const audience = process.env.VUE_APP_BACKEND_API_URL;
